export class ExternalTemplateInformation {
  code: string;
  name: string;

  clone(): ExternalTemplateInformation {
    const cloned = new ExternalTemplateInformation();
    cloned.code = this.code;
    cloned.name = this.name;
    return cloned;
  }
}
